import React from "react";

const Query = ({ customer, singleFeedback }) => {
  return (
    <div className="message-wrapper">
      <div className="messages flex-column">
        {singleFeedback &&
          singleFeedback.map((item, index) => (
            <div className={`single-message ${item.response_type} mt-3`}>
              <div className="d-flex justify-content-between align-items-center">
                {/* <h5>{item.extra_details.name}</h5> */}
              </div>
              <h6 className="text-capitalize">{item.entity_type}</h6>
              <p>{item.response_text}</p>
              <p className="time">{item.created_at}</p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default Query;
